import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Logo from "../components/Logo";

const SearchResultsPage = () => {
    const location = useLocation();
    const results = location.state?.results || [];
    const searchQuery = location.state?.query || "";
    const navigate = useNavigate();
    console.log('🔍 Search Results:', JSON.stringify(results, null, 2));

    const formatWeddingDate = (value) => {    console.log('🔍 Search Results:', JSON.stringify(results, null, 2));

        if (!value) return "";
        const d = typeof value?.toDate === "function" ? value.toDate() : new Date(value);
        return new Intl.DateTimeFormat("es-AR", {
            timeZone: "UTC",
            year: "numeric",
            month: "long",
            day: "numeric",
        }).format(d);
    };

    const today = new Date();
    const isUpcomingWedding = (value) => {
        const d = typeof value?.toDate === "function" ? value.toDate() : new Date(value);
        return d > today;
    };

    // ================= EMPTY STATE =================
    if (results.length === 0) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50">
                <header className="bg-white/80 backdrop-blur-sm border-b border-neutral-200">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
                        <Logo className="h-12 sm:h-14" />

                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full
                         bg-white border border-neutral-200 text-neutral-700
                         hover:bg-neutral-50 transition-colors font-semibold shadow-sm"
                        >
                            ← Volver
                        </Link>
                    </div>
                </header>

                <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
                    <div className="flex items-center justify-center">
                        <div
                            className="w-full max-w-md rounded-2xl border border-neutral-200
                 bg-white/80 backdrop-blur-sm
                 shadow-[0_10px_30px_-15px_rgba(0,0,0,0.15)]
                 px-8 py-10 text-center"
                        >
                            <div className="text-5xl mb-4">😕</div>

                            <h1 className="text-2xl font-display font-bold text-neutral-900 mb-2">
                                Lista no encontrada
                            </h1>

                            <p className="text-neutral-600 mb-8">
                                No pudimos encontrar esta lista de regalos.
                            </p>

                            <button
                                onClick={() => navigate(-1)}
                                className="inline-flex items-center justify-center px-6 py-3 rounded-xl
                   bg-accent-500 text-white font-semibold
                   hover:bg-accent-600 transition-colors"
                            >
                                Buscar de nuevo
                            </button>
                        </div>
                    </div>
                </main>


            </div>
        );
    }

    // ================= RESULTS =================
    return (
<div className="min-h-screen w-full bg-gradient-to-br from-accent-50 via-white to-primary-50">
            <header className="bg-white/80 backdrop-blur-sm border-b border-neutral-200 sticky top-0 z-40">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
                    <Logo className="h-12 sm:h-14" />

                    <div className="flex items-center gap-3">
                        {searchQuery && (
                            <div
                                className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full
                           bg-accent-50 border border-accent-100 text-accent-800 font-semibold"
                            >
                                🔎 “{searchQuery}”
                            </div>
                        )}

                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full
                         bg-white border border-neutral-200 text-neutral-700
                         hover:bg-neutral-50 transition-colors font-semibold shadow-sm"
                        >
                            ← Volver
                        </Link>
                    </div>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="mb-7">
                    <h1 className="text-2xl sm:text-3xl font-display font-bold text-neutral-900">
                        Resultados de búsqueda
                    </h1>
                    <p className="mt-2 text-neutral-600">
                        Encontramos{" "}
                        <span className="font-semibold text-neutral-900">{results.length}</span>{" "}
                        lista{results.length > 1 ? "s" : ""}
                        {searchQuery ? (
                            <>
                                {" "}para <span className="font-semibold text-neutral-900">“{searchQuery}”</span>
                            </>
                        ) : null}
                    </p>
                </div>

                <div className="grid gap-4">
                    {results.map((couple) => {
                        const upcoming = isUpcomingWedding(couple.weddingDate);

                        return (
                            <Link
                                key={couple.id}
                                to={`/lista/${couple.id}`}
                                className="group block rounded-2xl border border-neutral-200 bg-white/90 backdrop-blur
                           shadow-sm hover:shadow-[0_18px_60px_-30px_rgba(0,0,0,0.35)]
                           hover:border-accent-200 transition-all"
                            >
                                <div className="p-6 flex items-start justify-between gap-4">
                                    <div className="min-w-0">
                                        <div className="flex flex-wrap items-center gap-2">
                                            <h2 className="text-xl sm:text-2xl font-display font-semibold text-neutral-900 truncate">
                                                {couple.brideName} {couple.brideLastName} & {couple.groomName} {couple.groomLastName}
                                            </h2>

                                            {upcoming && (
                                                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold
                                         bg-accent-50 text-accent-700 border border-accent-100">
                                                    ✨ Próxima boda
                                                </span>
                                            )}
                                        </div>

                                        <div className="mt-2 flex items-center gap-2 text-neutral-600">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                />
                                            </svg>
                                            <span className="truncate">{formatWeddingDate(couple.weddingDate)}</span>
                                        </div>

                                        <p className="mt-4 inline-flex items-center gap-2 text-accent-700 font-semibold">
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M5 12h14M12 5l7 7-7 7"
                                                />
                                            </svg>
                                            Ver lista de regalos
                                        </p>
                                    </div>

                                    <div className="flex-shrink-0">
                                        <div className="w-11 h-11 rounded-full bg-neutral-100 border border-neutral-200
                                    flex items-center justify-center
                                    group-hover:bg-accent-50 group-hover:border-accent-200 transition-colors">
                                            <svg className="w-5 h-5 text-neutral-500 group-hover:text-accent-700 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>

                <div className="mt-10 text-center">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-accent-700 hover:text-accent-800 font-semibold transition-colors"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Volver al inicio
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default SearchResultsPage;
